<template>
    <div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div id="appointmentsTodos" class="todo-category accordion-item">
                <div class="accordion-header-container">
                    <div class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#appointmentTodo" aria-expanded="false" aria-controls="appointmentTodo">
                            <span class="round-icon bg-turquoise text-white me-3">
                                <i class="fa fa-calendar-o"></i>
                            </span>
                            <span class="title">Afspraken inplannen</span>
                            <span class="ms-auto badge amount rounded-pill text-bg-primary">
                                {{ this.count }}
                            </span>
                        </button>
                    </div>
                </div>

                <div id="appointmentTodo" class="accordion-collapse collapse" data-bs-parent="#todos">
                    <div class="accordion-body">

                        <div v-for="item in this.scheduleAppointments" class="todo">
                            <div class="todo-data">
                                <div class="col-170">
                                    <p class="mb-0">
                                        {{ item.name }}
                                    </p>
                                </div>
                                <div class="col-170">
                                    <p class="mb-0">
                                        {{ item.email }}
                                    </p>
                                </div>
                            </div>
                            <div class="actions ms-auto">
                                <a :href="item.url" target="_blank">
                                    <i class="fa fa-external-link text-lightgrey"></i>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    export default {
        name: 'todos-schedule-appointment',
        components: {},
        props: {},
        data() {
            return {
                scheduleAppointments: [{
                    key: {
                        id: '',
                        name: '',
                        email: '',
                        url: '',
                    }
                }],
                count: 0,
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            getCallBacks() {
                axios.get('api/todo-schedule-appointment')
                    .then(response => {
                        this.scheduleAppointments = response.data.scheduleAppointments;
                        this.count = response.data.count;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },

        },
        mounted() {
            this.getCallBacks();
        },
        created() {},
    }
</script>
